import React from "react";

import Auth from "../components/auth";
import AuthLayout from "../components/layout/auth";

export const AuthPage = () => (
  <AuthLayout>
    <Auth />
  </AuthLayout>
);
